module.exports = __webpack_public_path__ + "images/bannerDE-fcc6dc472d98ff78e405ef1e5eed1744.png";